import type { ReactNode } from "react";
import { BackToDesk } from "../atoms/BackToDesk.tsx";
import { SectionHead } from "../molecules/SectionHead.tsx";

export function SectionView({
  ariaLabel,
  title,
  sub,
  children,
}: {
  ariaLabel: string;
  title: string;
  sub: string;
  children: ReactNode;
}) {
  return (
    <main className="view active section-view" aria-label={ariaLabel}>
      <div className="wrap">
        <BackToDesk />
        <SectionHead title={title} sub={sub} />
        {children}
      </div>
    </main>
  );
}
